var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{staticClass:"fa",attrs:{"icon":"arrows-alt-h"}})
}
var staticRenderFns = []

export { render, staticRenderFns }